import React, { useState } from 'react'
import { Tooltip } from 'devextreme-react/tooltip'
import './ICSToolTip.css'

const ICSToolTip = ({
  id,
  icon = 'info',
  text,
  target,
  closeOnOutsideClick = true,
  children,
}: ICSToolTipProps) => {
  const [visible, setVisible] = useState(false)
  return (
    <div
      className='tooltip-wrapper'
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      &nbsp;
      <i
        id={id}
        className={`dx-icon-${icon}`}
        onClick={() => setVisible(!visible)}
      ></i>
      <Tooltip
        id={`${id}-overlay`}
        elementAttr={{ class: 'ics-tooltip-overlay' }}
        visible={visible}
        target={target}
        closeOnOutsideClick={closeOnOutsideClick}
        position='right'
        width='auto'
        maxWidth='fit-content'
      >
        <div>{text}</div>
      </Tooltip>
    </div>
  )
}

export default ICSToolTip

type ICSToolTipProps = {
  id: string
  icon?: string
  text: string
  target: string
  closeOnOutsideClick?: boolean
  children?: React.ReactNode
}
